/**
 * Suggestion chips for day regeneration instructions
 * Users can click these to append pre-written instruction text to their input
 */

export const DEFAULT_REGENERATION_SUGGESTIONS = [
  {
    id: 'relaxed',
    label: 'More relaxed pace',
    instruction: 'Make this day more relaxed with fewer activities and more downtime.'
  },
  {
    id: 'different-restaurants',
    label: 'Different restaurants',
    instruction: 'Suggest different restaurant options than what was originally planned.'
  },
  {
    id: 'more-beach',
    label: 'More beach time',
    instruction: 'Include more beach activities and relaxation time.'
  },
  {
    id: 'kid-friendly',
    label: 'More kid-friendly',
    instruction: 'Focus on activities that are better suited for young children.'
  },
  {
    id: 'local-food',
    label: 'More local food',
    instruction: 'Include more authentic local Hawaiian cuisine and local food spots.'
  },
  {
    id: 'less-driving',
    label: 'Less driving',
    instruction: 'Minimize driving time by keeping activities closer together.'
  },
  {
    id: 'outdoor-adventure',
    label: 'More adventure',
    instruction: 'Include more adventurous outdoor activities like hiking or water sports.'
  },
  {
    id: 'rainy-day',
    label: 'Rainy day alternatives',
    instruction: 'Provide activities that work well if it rains.'
  }
];
